module.exports = __webpack_public_path__ + "img/directory--avatar.6c59a284.svg";